import useUserPermission from "~/hooks/useUserPermission";

// Shows the Administration tab only to holders of `read:admin-grants`
// (Manifold Superusers), so User Managers without it don't see the tab.
export function useCanViewAdminGrants(): boolean {
  return useUserPermission("read:admin-grants");
}
